<template>
  <section class="viewsrhqyStoreManage_StoreSwitch">
    <viewTitle title="业务管理 / 基础数据管理 / 开关管理" :showReturn="false" />

    <el-form label-width="180px">
      <el-form-item label="司机须强制确认篷布防护">
        <el-radio-group v-model="enable" @change="changeVal">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">不启用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import viewTitle from "@/components/viewTitle";
export default {
  // 查询开关状态
  // 更新开关状态
  props: [""],

  data() {
    return {
      enable: ""
    };
  },

  computed: {},

  watch: {},

  components: { viewTitle },

  mixins: [],

  beforeRouteEnter(to, from, next) {
    next();
  },

  beforeRouteUpdate(to, from, next) {
    next();
  },

  beforeRouteLeave(to, from, next) {
    next();
  },

  beforeCreate() {},

  created() {
    this.$common
      .http({
        url: "/api/queue/basedata/list_switch",
        data: {}
      })
      .then(res => {
        let data = res.data.data;
        let config = data.filter(val => {
          return val.key === "tarpaulin_constraint_button";
        });
        console.log(config);
        this.enable = Number(config[0].value);
      });
  },

  beforeMount() {},

  mounted() {},

  beforeUpdate() {},

  updated() {},

  activated() {},

  deactivated() {},

  beforeDestroy() {},

  destroyed() {},

  errorCaptured() {},

  methods: {
    changeVal(val) {
      this.$common
        .http({
          url: "/api/queue/basedata/set_switch",
          data: {
            key: "tarpaulin_constraint_button",
            value: val
          }
        })
        .then(res => {
          if (Number(val) === 1) {
            this.$common.pcToastSuccess("启用成功");
          } else {
            this.$common.pcToastSuccess("关闭成功");
          }
          console.log(res);
        });
    }
  }
};
</script>
<style lang="less" scoped>
.viewsrhqyStoreManage_StoreSwitch {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
}
</style>
<style lang="less">
.viewsrhqyStoreManage_StoreSwitch {
}
</style>
